import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteBulkOperation } from '../apis/bulkOperationApi';
import { BulkOperation } from '../apis/types';

export const useDeleteBulkOperation = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (bulkOperationId: string) => {
      const token = await getAccessTokenSilently();
      return deleteBulkOperation(bulkOperationId, token);
    },
    onSuccess: (_data, bulkOperationId) => {
      queryClient.setQueryData(
        ['bulk-operations'],
        (old: unknown) =>
          Array.isArray(old)
            ? old.filter((op: BulkOperation) => op.id !== bulkOperationId)
            : old
      );
      queryClient.invalidateQueries({ queryKey: ['bulk-operations'] });
    },
  });

  return {
    deleteBulkOperation: mutation.mutateAsync,
    isDeleting: mutation.isPending,
  };
};
